import { REDIRECTION_TYPES } from "../../../../helpers/utils";

export const getTaskRedirection = (scopeId, taskId) => {
    if(!scopeId || !taskId) return;

    return `/scopes/${scopeId}/overview?r_id=${taskId}`;
};

export const getScopeRedirection = (scopeId) => {
    if(!scopeId) return;

    return `/scopes/${scopeId}/overview`;
};

export const getProjectRedirection = (projectId, type, id) => {
    if(!projectId || !type || !id) return;

      let redirectionType;
      switch (type) {
        case 'changerequest':
          redirectionType = REDIRECTION_TYPES.CHANGE_REQUEST;
          break;
        case 'communicationplan':
          redirectionType = REDIRECTION_TYPES.COMMUNICATION;
          break;
        case 'budget':
          redirectionType = REDIRECTION_TYPES.BUDGET;
          break;
        case 'risk':
          redirectionType = REDIRECTION_TYPES.RISK;
          break;
        case 'task':
          redirectionType = REDIRECTION_TYPES.TASK;
          break;
        default:
          return;
      }

      return `/projects/${projectId}/overview?r_t=${redirectionType}&r_id=${id}`;

  };